import React, { FC } from 'react';

import illustrationMoverWithSixteenFootTruck from '@images/illustrations/mover_with_sixteen_foot_truck.svg';
import illustrationOnlinePhotoCatalog from '@images/illustrations/online_photo_catalog_large.svg';
import illustrationSelfStorageUnit from '@images/illustrations/self_storage_unit.svg';

import { InfoCardItem } from './info_card_item';
import { InfoCardList } from './info_card_list';

const DEFAULT_TITLE = 'How Clutter Storage Works';

export const HowClutterStorageWorks: FC<{
  title?: string;
}> = ({ title = DEFAULT_TITLE }) => (
  <InfoCardList title={title}>
    <InfoCardItem
      label="1"
      title={<>We pick up your stuff</>}
      subtitle={<>Professional movers wrap, pack, and carry your stuff.</>}
      icon={illustrationMoverWithSixteenFootTruck}
    />
    <InfoCardItem
      label="2"
      title={
        <>
          <div>We store it in a secure,</div>
          <div>climate controlled facility</div>
        </>
      }
      subtitle={<>Truck and transportation included.</>}
      icon={illustrationSelfStorageUnit}
    />
    <InfoCardItem
      label="3"
      title="We bring it back on demand"
      subtitle="Schedule a delivery of your stuff with a tap."
      icon={illustrationOnlinePhotoCatalog}
    />
  </InfoCardList>
);
